/**
 * This has to be listed here:
 *   app/public/wp-content/mu-plugins/wp-common-plugin/src/Gutenberg/Blocks/webpack.config.js
 */
( function( $ ) {
	'use strict';
	$( document ).ready( function() {
		const $containers = $( '.requirements-block' )
		if ( !$containers.length ) {
			return;
		}
		$containers.each( ( idx, container ) => {
			const $container = $( container );
			$container.find( 'section' ).each( function() {
				$( this ).find( '.view-more' ).on( 'click', function() {
					const $more = $( this );
					$more.parent().toggleClass( 'collapsed' )
					$more.text( $more.text() === 'View More' ? 'View Less' : 'View More' );
				} );
			} )
		} );
	} );
} )( jQuery );
